<template>
  <div class="d-flex" style="align-items: center;">
    <div v-if="item.has_banking_transaction" class="status-circle-badge badge-blue" v-b-tooltip.hover :title="$gettext('Connected to a bank transaction')">
      <font-awesome-icon icon="fa-solid fa-building-columns" />
    </div>
    <div v-if="item.created_via === 'woocommerce'" class="status-circle-badge badge-image" v-b-tooltip.hover :title="$gettext('Created via Woocommerce')">
        <img src="/static/img/woocommerce2.png" />
    </div>
    <div v-if="item.credited_invoice" class="status-circle-badge badge-brown" v-b-tooltip.hover :title="$gettext('Credited')">
      <font-awesome-icon icon="fa-solid fa-rotate-left" />
    </div>
    <div v-if="item.currency !== 'EUR'" class="status-circle-badge badge-blue" v-b-tooltip.hover :title="$gettext('Foreign currency')">
      <font-awesome-icon icon="fa-solid fa-dollar-sign" />
    </div>
    <div v-if="item.display_status.error" class="status-circle-badge badge-danger" v-b-tooltip.hover :title="$gettext('Error sending the invoice')">
      <font-awesome-icon icon="fa-solid fa-triangle-exclamation" />
    </div>
    <div v-if="!item.display_status.error && item.display_status.detailed_status === 'sending'" class="status-circle-badge badge-spinner" v-b-tooltip.hover :title="$gettext('Sending')">
    </div>
    <div v-if="item.uploaded || item.correction" class="status-circle-badge badge-blue" v-b-tooltip.hover :title="$gettext('Uploaded')">
      <font-awesome-icon icon="fa-solid fa-cloud-arrow-up" />
    </div>
    <div v-if="(item.status === 's' || item.status === 'p') && item.verifactuinvoice && 
              (item.verifactuinvoice.status == 'correct' || item.verifactuinvoice.status == 'partially_correct' || 
              item.verifactuinvoice.status == 'cancellation_incorrect' || item.verifactuinvoice.status == 'error_cancelling')" 
        v-b-tooltip.hover :title="$gettext('Invoice sent to AEAT')">
        <CustomIcon name="aeat" :width="22" :height="22" />
    </div>
    <div v-if="(item.status === 's' || item.status === 'p') && item.verifactuinvoice && 
              (item.verifactuinvoice.status == 'cancelled' || item.verifactuinvoice.status == 'cancelled_with_errors')" 
        v-b-tooltip.hover :title="$gettext('Invoice canceled in the AEAT')">
        <CustomIcon name="aeat-red" :width="22" :height="22" />
    </div>

    <div v-if="(item.status === 's' || item.status === 'p') && (item.peppolinvoice && (item.peppolinvoice.status && item.peppolinvoice.status !== 'draft'))" 
        v-b-tooltip.hover :title="$gettext('Invoice sent via Peppol')">
        <CustomIcon name="peppol" color="#02a9f4" />
    </div>
  </div>
</template>

<script>
import CustomIcon from '@/components/ui/CustomIcon.vue';

export default {
  name: 'StatusIcons',
  components: {
    CustomIcon
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {

  },
}
</script>

<style lang="scss" scoped>

</style>